export const UserActivityLogs = {
  en: {
    'User Activity Logs': 'User Activity Logs',
    Time: 'Time',
    User: 'User',
    Client: 'Client',
    Service: 'Service',
    'Action Type': 'Action Type',
    'Purchased Service Id': 'PS Id',
    'Service Usage History Id': 'SUH Id',
    'Payment Id': 'Payment Id',
    Details: 'Details',
    Before: 'Before',
    After: 'After',
  },
  uk: {
    'User Activity Logs': 'Журнал',
    Time: 'Час',
    User: 'Користувач',
    Client: 'Клієнт',
    Service: 'Сервіс',
    'Action Type': 'Тип Дії',
    'Purchased Service Id': 'Id сер.',
    'Service Usage History Id': 'SUH Id',
    'Payment Id': 'Id Платежу',
    Details: 'Деталі',
    Before: 'До',
    After: 'Після',
  },
};
